import { render, staticRenderFns } from "./CompQuestion.vue?vue&type=template&id=21ca77f2&scoped=true"
import script from "./CompQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./CompQuestion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompQuestion.vue?vue&type=style&index=0&id=21ca77f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca77f2",
  null
  
)

export default component.exports